module.exports = __webpack_public_path__ + "img/download.0868c328.svg";